module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('mu-appbar', {
    staticClass: "header"
  }, [_c('mu-icon-button', {
    attrs: {
      "icon": "arrow_back"
    },
    on: {
      "click": _vm.goback
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "icon": "email",
      "to": "/vue-home/dist/message"
    },
    slot: "right"
  }), _vm._v(" "), _c('span', {
    staticClass: "my-news-title"
  }, [_vm._v("个人中心")])], 1), _vm._v(" "), _c('mu-list', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "my-information"
  }, [_c('img', {
    attrs: {
      "src": _vm.peopleUsg.avatar_url,
      "alt": "user"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "timer"
  }, [_c('span', {
    staticClass: "name"
  }, [_c('b', [_vm._v(_vm._s(_vm.peopleUsg.loginname))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("积分：" + _vm._s(_vm.peopleUsg.score))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("注册时间：" + _vm._s(_vm._f("formatDate")(_vm.peopleUsg.create_at)))])])]), _vm._v(" "), (_vm.peopleUsg.recent_topics) ? _c('mu-list-item', {
    staticClass: "my-information-firstitem list-item",
    attrs: {
      "title": "最近的话题",
      "toggleNested": "",
      "open": false
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "chat"
    },
    slot: "left"
  }), _vm._v(" "), _vm._l((_vm.peopleUsg.recent_topics), function(item) {
    return _c('mu-list-item', {
      key: item.id,
      staticClass: "list-item-content",
      attrs: {
        "to": {
          path: '/vue-home/dist/content',
          query: {
            id: item.id
          }
        },
        "title": "Starred",
        "title": item.title,
        "afterText": _vm._f("formatDate")(item.last_reply_at)
      },
      slot: "nested"
    }, [_c('mu-icon', {
      attrs: {
        "value": "hdr_weak"
      },
      slot: "left"
    })], 1)
  }), _vm._v(" "), _c('span', {
    staticClass: "msg-num"
  }, [_vm._v(_vm._s(_vm.peopleUsg.recent_topics.length))])], 2) : _vm._e(), _vm._v(" "), (_vm.peopleUsg.recent_replies) ? _c('mu-list-item', {
    staticClass: "list-item",
    attrs: {
      "title": "最近的回复",
      "toggleNested": "",
      "open": false
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "public"
    },
    slot: "left"
  }), _vm._v(" "), _vm._l((_vm.peopleUsg.recent_replies), function(item) {
    return _c('mu-list-item', {
      key: item.id,
      staticClass: "list-item-content",
      attrs: {
        "to": {
          path: '/vue-home/dist/content',
          query: {
            id: item.id
          }
        },
        "title": "Starred",
        "title": item.title,
        "afterText": _vm._f("formatDate")(item.last_reply_at)
      },
      slot: "nested"
    }, [_c('mu-icon', {
      attrs: {
        "value": "hdr_weak"
      },
      slot: "left"
    })], 1)
  }), _vm._v(" "), _c('span', {
    staticClass: "msg-num"
  }, [_vm._v(_vm._s(_vm.peopleUsg.recent_replies.length))])], 2) : _vm._e(), _vm._v(" "), (_vm.peopleUsg.collect_topics) ? _c('mu-list-item', {
    staticClass: "list-item",
    attrs: {
      "title": "收藏的话题",
      "toggleNested": "",
      "open": false
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "star"
    },
    slot: "left"
  }), _vm._v(" "), _vm._l((_vm.peopleUsg.collect_topics), function(item) {
    return _c('mu-list-item', {
      key: item.id,
      staticClass: "list-item-content",
      attrs: {
        "to": {
          path: '/vue-home/dist/content',
          query: {
            id: item.id
          }
        },
        "title": "Starred",
        "title": item.title,
        "afterText": _vm._f("formatDate")(item.last_reply_at)
      },
      slot: "nested"
    }, [_c('mu-icon', {
      attrs: {
        "value": "hdr_weak"
      },
      slot: "left"
    })], 1)
  }), _vm._v(" "), _c('span', {
    staticClass: "msg-num"
  }, [_vm._v(_vm._s(_vm.peopleUsg.collect_topics.length))])], 2) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-164b8710"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/people.vue
// module id = 137
// module chunks = 1